import { BaseCustomFeatures } from './base';
import { i18n } from '@vendor/libs/lang/lang';
import infectionsStyle, { infectionHighlightedStyle, infectionRegularStyle, } from '../styles/infections/infections';
import { Feature } from 'ol';
import { Circle } from 'ol/geom';
export class InfectionFeatures extends BaseCustomFeatures {
    constructor(options = {}) {
        super('infections', {
            style: infectionsStyle,
            visibilityLabel: i18n.trans('map.features.infections.label'),
            ...options,
        });
        this.on('add', ({ feature }) => {
            const features = [];
            // add 6km buffer
            const circleFeature = new Feature({
                geometry: new Circle(feature.getGeometry().getCoordinates(), 9656),
            });
            features.push(circleFeature);
            this._addRelated(features, feature, this.options.relatedName ?? 'infection-buffers');
        });
    }
    getLegendItems() {
        if (this.features.find((f) => f.get('highlighted'))) {
            return [
                {
                    geomType: 'Circle',
                    style: infectionHighlightedStyle,
                    title: i18n.trans('map.interface_elements.legend.infections.highlighted'),
                },
            ];
        }
        return [
            {
                geomType: 'Circle',
                style: infectionRegularStyle,
                title: i18n.trans('map.interface_elements.legend.infections.regular'),
            },
        ];
    }
}
